var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trp-percentage-bar"},[_c('div',{staticClass:"trp-percentage-bar-inner",style:({ width: _vm.getPercentage() })}),_vm._v(" "),_c('div',{staticClass:"trp-filled-area",style:({ width: _vm.getPercentage() })})])
}
var staticRenderFns = []

export { render, staticRenderFns }